import React from 'react';

export default function MedicationSummary({hide, summary}) {
  //console.log('MedSummary', hide, summary);
  if (hide) return (<></>);
  
  const medsHowMuch = ['POWDER','LIQUID'].includes(summary.form);
  //const manyMuch = medsHowMuch ? 'much': 'many';

  let howOften = '';
  // let strength = summary.strength;
  // let howMany = summary.dosage;
  // if (medsHowMuch) {
  //   switch (strength)
  //   {
  //     case 't':
  //       howMany += ' Tsp';
  //       break;
  //     case 'T':
  //       howMany += ' Tbsp';
  //       break;
  //     case 'ml':
  //       howMany += ' ML';
  //       break;
  //     default:
  //       break;
  //   }
  //   strength = '';
  // }

  if (summary.often === 'hourly') {
        if ( summary.occurance > 0) howOften = `Every ${summary.occurance} hour(s)`;
    }
  else if (summary.often === 'daily') {
    howOften = `${summary.occurance} time(s) daily`;
    }
  else if (summary.often === 'everyndays') {
    howOften = `Every ${summary.occurance} days`;
    }
  else if (summary.often === 'weekly') {
      howOften = `${summary.occurance} time(s) per week`;
      }
  else if (summary.often === 'asNeeded') {
    howOften = 'As needed';
    }
  else {
    howOften = 'Not indicated';
    }
        
  let medName = summary.name;
  let medType = '';
  switch (summary.type)
  {
    case 'S':
      medType = "Supplement";
      break;
    case 'P':
      medType = "Prescription";
      break;
    case 'C':
      medType = "Over the counter";
      break;
          default:
      medType = "Other";
      break;
  }
  if (summary.brand && summary.name !== summary.brand) medName += ' (' + summary.brand + ')';

  return (
    <div className='flex flex-col pt-4 w-full max-w-[800px]'>
        <div className='py-2 flex justify-center min-w-full px-4 phone:px-6 tablet:px-8'>
        <table className='medTable'>
            <tbody className='medTbody'>
            <tr>
                <td> Medication </td>
                <td> {medName} </td>
            </tr>
            <tr>
                <td> Type </td>
                <td> {medType} </td>
            </tr>
            <tr>
                <td> Form </td>
                <td> {summary.form} </td>
            </tr>
            <tr>
                <td> Strength </td>
                <td> {summary.strength} </td>
            </tr>
            <tr>
                <td> Dosage </td>
                <td> {summary.dosage} </td>
            </tr>
            <tr>
                <td> How Often </td>
                <td> {howOften} </td>
            </tr>
            <tr>
                <td> Dose Times </td>
                <td>
                    {summary.schedule && summary.schedule.map((s,ix) => {
                      return (<div key={ix}>{summary.schedule[ix]}<br/></div>);
                      })
                    }
                </td>
            </tr>
            </tbody>
        </table>
        </div>
    </div>
  );
}
